import { render } from "./NotifyLayer.vue?vue&type=template&id=551954a8&scoped=true"
import script from "./NotifyLayer.vue?vue&type=script&lang=js"
export * from "./NotifyLayer.vue?vue&type=script&lang=js"

import "./NotifyLayer.vue?vue&type=style&index=0&id=551954a8&scoped=true&lang=scss"

import exportComponent from "/home/parshin/rnews-cabinet/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551954a8"]])

export default __exports__